import { createContext, useContext } from "react";
const SIZE_SMALL = "small";
const SIZE_LARGE = "large";

/**
 * Formularbezug der Kit-Bausteine (Plan 2026-10-13-antd-ausbau, Stufe 7): `<Form disabled>` sperrt Felder und Knöpfe,
 * `<Form size>` gilt für Felder, ein Fehler am `Form.Item` färbt das Feld. Die Kontexte stellt die Formularfassade
 * des Kits (`ui/Form.tsx`) bereit; vorher lasen die Bausteine die Antd-internen Kontexte.
 */
export const KitDisabledContext = createContext<boolean | undefined>(undefined);
export const KitSizeContext = createContext<"small" | "middle" | "large" | undefined>(undefined);
export const FormItemStatusContext = createContext<{ status: "error" | "warning" | "" }>({ status: "" });

/**
 * Nur-Lesen-Sperre (z. B. `FormDrawer readOnly`): sperrt alle Kit-Bedienelemente darunter,
 * auch solche mit ausdrücklichem `disabled={false}` (etwa `Form disabled={saving}`).
 */
export const KitLockedContext = createContext(false);

export function useKitDisabled(disabled?: boolean): boolean {
  const inherited = useContext(KitDisabledContext);
  const locked = useContext(KitLockedContext);
  return locked || (disabled ?? inherited ?? false);
}

export function useKitSize(size?: string): "small" | "middle" | "large" | undefined {
  const inherited = useContext(KitSizeContext);
  const resolved = size ?? inherited;
  if (resolved === SIZE_SMALL || resolved === SIZE_LARGE) return resolved;
  return resolved ? "middle" : undefined;
}

export function useKitFieldStatus(status?: "error" | "warning" | ""): "error" | "warning" | undefined {
  const item = useContext(FormItemStatusContext);
  const resolved = status || item.status;
  return resolved === "error" || resolved === "warning" ? resolved : undefined;
}

export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
